import React from 'react';
import {Button, Card} from "react-bootstrap";
import { BsExclamationTriangleFill } from "react-icons/bs";

const RootFallBackComponent = () => {
    const handleReload = () => {
        window.location.href = '/';
    };

    return (
        <Card className="shadow-lg m-5 bg-white" style={{ borderRadius: "20px" }}>
            <Card.Title className="d-flex flex-row justify-content-center">
                <BsExclamationTriangleFill size={25} className="errorImage" />
            </Card.Title>
            <Card.Body className="m-0 p-0 d-flex flex-column justify-content-center align-items-center">
                <h6 className="ms-1 me-1 font-sub errorText">
                    Oops. Something went wrong. Please download our Mobile App for quick
                    ordering or try again.
                </h6>
                <Button
                    className="m-3 order-now-card-button"
                    onClick={handleReload}
                >
                    Try Again
                </Button>
            </Card.Body>
        </Card>
    );
};
export default RootFallBackComponent;
